export default __webpack_public_path__ + "025aa93221d618f490ba207ececc7f2e.svg";